module.exports = __webpack_public_path__ + "media/images/eye_icon_inverse-5a31ef6bd738e3be571fb3de6491044d.jpg";